import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-readonly-input',
  templateUrl: './readonly-input.component.html',
  styleUrl: './readonly-input.component.scss'
})
export class ReadonlyInputComponent {

  @Input() value:string | undefined | null="";
  @Input() type:'date'|'text' | 'textarea'="text";
  @Input() showHour:boolean=false;
  @Input() style={}
  @Input() classS=''
}
